import {Fancybox} from "@fancyapps/ui";

export function init() {
  Fancybox.bind(`.wp-block-gallery:not(.list-of-logos) .wp-block-image a img`, {
    groupAll: true
  });
}